module.exports = __webpack_public_path__ + "img/5.31e8f729.jpg";